import moment from 'moment';
import * as Yup from 'yup';
import { isValidPhoneNumber } from "react-phone-number-input";

export const signInSchema = Yup.object().shape({
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        ),
    password: Yup.string()
        .required("Please enter password")
        .min(8, "Password cannot be less than 8 characters")
});

export const signUpSchema = Yup.object().shape({
    first_name: Yup.string().trim().required("Please enter a first name"),
    last_name: Yup.string().trim().required("Please enter a last name"),
    company_name: Yup.string().trim().required("Please enter company name"),
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        ),
    phone_no: Yup.string()
        .required("Please enter phone number")
        .test("is-valid-phone", "Please enter valid phone number", (value) =>
            isValidPhoneNumber(value || "")
        ),
    password: Yup.string()
        .required("Please enter password")
        .min(8, "Password cannot be less than 8 characters")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
            "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
        ),
    confirm_password: Yup.string()
        .required("Please enter confirm password")
        .oneOf([Yup.ref("password"), null], "password must match"),
    agreeTerms: Yup.boolean()
        .oneOf([true], 'You must agree to the Terms & Conditions'),
    agreePrivacy: Yup.boolean()
        .oneOf([true], 'You must agree to the Privacy Policy'),
    agreeAcceptableUse: Yup.boolean()
        .oneOf([true], 'You must agree to the Acceptable Use Policy')
});

export const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        )
});

export const UpdateUserSchema = Yup.object().shape({
    full_name: Yup.string().trim().matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)+$/, 'Please enter full name (first and last name).')
        .required("Please enter a full name"),
    username: Yup.string().trim().required("Please enter a user name")
});

export const ChangePasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required("Please enter current password"),
    new_password: Yup.string()
        .required("Please enter new password")
        .min(8, "Password cannot be less than 8 characters")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
            "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
        ),
    confirm_password: Yup.string()
        .required("Please enter confirm password")
        .oneOf([Yup.ref("new_password"), null], "password must match"),
});

export const AddStaffSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter name"),
    role: Yup.array()
        .of(Yup.number().required("Invalid job role"))
        .min(1, "Please select job role")
        .required("Please select job role"),
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter a valid email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        ),
    phone_no: Yup.string()
        .required("Please enter contact number")
        .test("is-valid-phone", "Please enter valid contact number", (value) =>
            isValidPhoneNumber(value || "")
        ),
    password: Yup.string()
        .required("Please enter password")
        .min(8, "Password cannot be less than 8 characters")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
            "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
        ),
    home_address: Yup.string().trim().required("Please enter home address"),
    hourly_rate: Yup.string().trim()
        .min(1, "Hourly Rate must be at least 1 digit long")
        .max(5, "Hourly Rate must be at most 5 digits long").required("Please enter hourly rate").test('not-zero', 'Hourly Rate cannot be zero', value => value !== '0')
});

export const UpdateStaffSchema = Yup.object().shape({
    full_name: Yup.string().trim().required("Please enter name"),
    role: Yup.array()
        .of(Yup.number().required("Invalid job role"))
        .min(1, "Please select job role")
        .required("Please select job role"),
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter a valid email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        ),
    phone_no: Yup.string()
        .required("Please enter contact number")
        .test("is-valid-phone", "Please enter valid contact number", (value) =>
            isValidPhoneNumber(value || "")
        ),
    password: Yup.string()
        .required("Please enter password")
        .min(8, "Password cannot be less than 8 characters")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
            "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
        ),
    home_address: Yup.string().trim().required("Please enter home address"),
    status: Yup.string().required("Please add status"),
    hourly_rate: Yup.string().trim()
        .min(1, "Hourly Rate must be at least 1 digit long")
        .max(5, "Hourly Rate must be at most 5 digits long").required("Please enter hourly rate").test('not-zero', 'Hourly Rate cannot be zero', value => value !== '0')
});

export const AddSupplierSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter supplier name"),
    email: Yup.string()
        .email("Please enter a valid email address")
        .required("Please enter email address")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email address"
        )
});

export const AddBoatSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter boat name"),
    owners_name: Yup.string().trim().required("Please enter owner's name"),
    boat_type: Yup.string().trim().required("Please select boat type"),
    rego: Yup.string().trim().required("Please enter rego"),
    boat_length_category: Yup.string().trim().required("Please select boat length"),
    vin: Yup.string().trim()
        .optional(),
    make: Yup.string().trim().required("Please enter make"),
    model: Yup.string().trim().required("Please enter model"),
    engine_no: Yup.number()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        .optional()
        .positive("Engine length must be greater than 0")
        .typeError("Engine number must be a valid number"),
    engine_make: Yup.string().trim().optional(),
    engine_model: Yup.string().trim().optional(),
    email: Yup.string()
        .email("Please enter valid email")
        .required("Please enter valid email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter valid email"
        ),
    phone_no: Yup.string()
        .required("Please enter phone number")
        .test("is-valid-phone", "Please enter valid phone number", (value) =>
            isValidPhoneNumber(value || "")
        ),
    length: Yup.number()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        // .required("Please enter boat length")
        .optional()
        .positive("Boat length must be greater than 0")
        .typeError("Boat length must be number"),
    book_from: Yup.date()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        .typeError("Please select valid date")
        .optional(),
    book_to: Yup.date()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        .min(Yup.ref('book_from'), "End date must be the same as or later than the book from date.")
        .typeError("Please select valid date")
        .optional(),
    app_date: Yup.date()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        // .required("Please select app date")
        .typeError("Please select valid date").optional(),
    docking_date: Yup.date()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? undefined : value
        )
        // .required("Please select docking date")
        .typeError("Please select valid date")
        .optional(),
});

export const AddDockSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter dock name"),
    dock_length_category: Yup.string().required("Please enter dock capacity(length)"),
    email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter email")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
            "Please enter a valid email"
        ),
    phone_no: Yup.string()
        .required("Please enter contact number")
        .test(
            "is-valid-phone",
            "Please enter valid contact number",
            (value) => isValidPhoneNumber(value || "")
        ),
    // book_from: Yup.date()
    //     .required("Please select booking date")
    //     .typeError("Please select valid date"),
    // book_to: Yup.date()
    //     .required("Please select booking end date")
    //     .min(Yup.ref('book_from'), "End date must be the same as or later than the book from date.")
    //     .typeError("Please select valid date"),
    address: Yup.string().trim().required("Please enter storage address"),
    booking_cost: Yup.number()
        .typeError("Please enter a valid number")
        .positive("Booking Cost must be greater than 0")
        .max(999999999, "Booking Cost is too large") // optional limit
        .required("Please enter booking cost"),

    booking_cost_per_day: Yup.number()
        .typeError("Please enter a valid number")
        .positive("Cost must be greater than 0")
        .max(999999999, "Cost is too large") // optional limit
        .required("Please enter booking cost/day"),
});

export const UpdateSupplierSchema = Yup.object().shape({
    company_name: Yup.string().trim().required("Please enter company name"),
    company_description: Yup.string().trim().required("Please enter company description"),
    city: Yup.string().trim().required("Please enter city"),
    phone_no: Yup.string()
        .matches(/^[0-9]+$/, "Phone number must be number")
        // .min(10, "Contact number cannot be less then 10 digits").max(10, "Contact number can not be more then 10 digits")
        .required("Please enter phone number")
});

export const AddLeadSchema = Yup.object().shape({
    client_name: Yup.string().trim().required("Please enter client name"),
    client_contact_number: Yup.string()
        .required("Please enter contact number")
        .test("is-valid-phone", "Please enter valid contact number", (value) =>
            isValidPhoneNumber(value || "")
        ),
    notes: Yup.string().trim().optional(),
});

export const ServicePresetSchema = Yup.object().shape({
    serviceTitle: Yup.string().trim().required("Please enter service title"),
    serviceCost: Yup.number()
        .typeError("Please enter a valid service cost")
        .positive("Service cost must be greater than 0")
        .required("Please enter service cost"),
    boatLength: Yup.string()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable(),
    materialCost: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .typeError("Please enter a valid material cost")
        .positive("Material cost must be greater than 0"),
    });

export const CreateTaskSchema = Yup.object().shape({
    description: Yup.string().trim().required("Please enter maintenance item description"),
    time_alloted: Yup.string().trim()
        .min(1, "Time allocated must be at least 1 digit long")
        .max(5, "Time allocated must be at most 5 digits long")
        .required("Please enter time allocated").test('not-zero', 'Time allocated cannot be zero', value => value !== '0'),
    quoted_value: Yup.string().trim()
        .min(1, "Quoted value must be at least 1 digit long")
        .max(5, "Quoted value must be at most 5 digits long").required("Please enter quoted value").test('not-zero', 'Quoted value cannot be zero', value => value !== '0'),
    // boatId: Yup.string().trim().required("Please select boat registration"),
    assignStaffId: Yup.string().required("Please select staff member"),
    supplierId: Yup.mixed().when('assignStaffId', {
        is: 'STAFF',
        then: (schema) => schema.required("Please select technician / staff"),
        otherwise: (schema) => schema.test('is-array-not-empty', 'Please select at least one supplier', value => {
            return Array.isArray(value) && value.length > 0;
        }).required("Please select at least one supplier")
    }),
    date_scheduled_from: Yup.date()
        .required("Please select scheduled from")
        .typeError("Please select valid date"),
    date_scheduled_to: Yup.date()
        .required("Please select scheduled to")
        .min(Yup.ref('date_scheduled_from'), "End date must be the same as or later than the scheduled from date.")
        .typeError("Please select valid date"),
    scheduled_start_time: Yup.date()
        .when("assignStaffId", {
            is: "STAFF",
            then: (schema) =>
                schema
                    .required("Please select start time")
                    .typeError("Please select valid time")
                    .test(
                        "is-between",
                        "Start time must be on or between scheduled from and scheduled to dates.",
                        function (value) {
                            const { date_scheduled_from, date_scheduled_to } = this.parent;
                            if (!value || !date_scheduled_from || !date_scheduled_to) return true;
                            const startDate = moment(value).startOf("day");
                            const fromDate = moment(date_scheduled_from).startOf("day");
                            const toDate = moment(date_scheduled_to).startOf("day");
                            return startDate.isSameOrAfter(fromDate) && startDate.isSameOrBefore(toDate);
                        }
                    )
                    .test(
                        "not-in-past",
                        "Start time cannot be in the past.",
                        function (value) {
                            if (!value) return true;
                            return moment(value).isSameOrAfter(moment());
                        }
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    completed_at: Yup.date()
        .min(Yup.ref('date_scheduled_from'), "Completed At must be the same as or later than the scheduled from date.")
        .max(Yup.ref('date_scheduled_to'), "Completed At must be the same as or before the scheduled to date.")
        .typeError("Please select valid date"),
});

export const AssignBoatSchema = Yup.object().shape({
    boatId: Yup.string().required("Please select boat")
});

export const CreateMaintenanceSchema = Yup.object().shape({
    boatId: Yup.string().trim().required("Please select boat"),
    selectedServiceId: Yup.string().trim().optional(),
    services: Yup.array()
        .of(Yup.number().required("Invalid service"))
        .min(1, "Please add at least one service"),
});

export const AddPartSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter part name"),
    part_number: Yup.string().trim().required("Please enter part number"),
    manufacturer: Yup.string().trim().required("Please enter manufacturer"),
    serial_number: Yup.string().trim().required("Please enter serial number"),
    original_cost: Yup.number()
        .typeError("Please enter a valid original cost")
        .positive("Original cost must be greater than 0")
        .required("Please enter original cost"),
    boat_owner_cost: Yup.number()
        .typeError("Please enter a valid boat owner cost")
        .positive("Boat owner cost must be greater than 0")
        .required("Please enter boat owner cost"),
    stock_quantity: Yup.number()
        .typeError("Please enter a valid stock quantity")
        .integer("Stock quantity must be a whole number")
        .min(0, "Stock quantity cannot be negative")
        .required("Please enter stock quantity"),
    low_stock_alert: Yup.number()
        .typeError("Please enter a valid low stock alert")
        .integer("Low stock alert must be a whole number")
        .min(0, "Low stock alert cannot be negative")
        .required("Please enter low stock alert"),
    // warranty_duration: Yup.number()
    //     .typeError("Please enter a valid warranty duration")
    //     .integer("Warranty duration must be a whole number")
    //     .min(0, "Warranty duration cannot be negative")
    //     .required("Please enter warranty duration"),
    // warranty_type: Yup.string().trim().required("Please select warranty type"),
});

export const CdsJobServiceSchema = Yup.object().shape({
    work_including_materials: Yup.string().required("Please enter work carried out"),
});

export const CdsMaterialNameValidation = Yup.string()
    .trim()
    .required('Field is required');

export const CdsMaterialWholeNumberValidation = Yup.string()
    .trim()
    .matches(/^\d+$/, 'Only numbers are allowed, and decimal values are not allowed.')
    .required('Field is required');

export const CdsMaterialNumberValidation = Yup.string()
    .trim()
    .matches(/^\d*\.?\d+$/, 'Only numbers are allowed')
    .required('Field is required');

export const CdsMaterialFieldValidations = [
    CdsMaterialNameValidation,
    CdsMaterialWholeNumberValidation,
    CdsMaterialNumberValidation,
    CdsMaterialNumberValidation,
];

export const SelectedPartSchema = Yup.object().shape({
    selectedPartId: Yup.string().required("Please select part"),
    quantity: Yup.number().typeError("Please enter a valid quantity").integer("Quantity must be a whole number").min(1, "Quantity must be at least 1").required("Please enter quantity"),
});

export const BoatPartSchema = Yup.object().shape({
    installedDate: Yup.date()
        .required("Please select installed date"),
    warrantyStartDate: Yup.date()
        .required("Please select warranty start date"),
    notes: Yup.string()
        .trim()
        .optional()
        .nullable(),
});

// ── Same as Supplier Portal ────────────────────────────────────────────────

export const MaintenanceTasks = Yup.object().shape({
    task_info: Yup.string().required("Please enter task info"),
    supplier_notes: Yup.string().required("Please enter supplier notes"),
    watch_list: Yup.string().required("Please enter watch list"),
    due_date: Yup.string().required("Please enter due date"),
});

export const PartQuantitySchema = Yup.object().shape({
    quantity: Yup.number()
        .typeError("Please enter quantity")
        .positive("Quantity must be greater than 0")
        .integer("Only whole numbers are allowed")
        .required("Quantity is required"),
});

export const ExtraPartSchema = Yup.object().shape({
    partName: Yup.string()
        .trim()
        .required("Part name is required"),
    unitsUsed: Yup.number()
        .typeError("Quantity is required")
        .positive("Only positive whole numbers are allowed.")
        .integer("Only positive whole numbers are allowed.")
        .required("Quantity is required"),
});

